import DialogComponentWithBodyChildren from "./DialogComponentWithBodyChildren";
import React from "react";
import {useTranslation} from "react-i18next";

export default function VideoRecorderPrestart(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'videoRecorder'});

    return <DialogComponentWithBodyChildren
        onClose={props.close}
        onConfirm={props.confirm}
        title={t('attentionVideoOn')}
    >
        <h5>{t('attentionText1')}</h5>
        <ul>
            <li><b>{t('attentionText2')}</b></li>
            <small>{t('attentionText3')}</small>
            <a href={i18n.language === "en" ? "/about_recording_en" : "/about_recording"}
               target="_blank">{t('aboutRecordPage')}</a>
            <li><b>{t('playersAgreed')} </b></li>
            <small>{t('personalResponsibility')}</small>
        </ul>

        <div>{t('setup1')}</div>
        <br/>
        <div>{t('setup2')}</div>
        <br/>
        <br/>
        <div>{t('recordOn')}</div>
    </DialogComponentWithBodyChildren>
}